import Form from './components/Form';
import { useEffect, useState } from 'react';
import { Error } from './helpers/errors';
import styled from 'styled-components';
import { NotificationPopup, searchParams } from '../../libs';
import '../../i18n/i18n';
import i18n from '../../i18n/i18n';
import AppEmptyPage from '../../components/AppEmptyPage';
import { Loader } from '../../libs';
import { createGlobalStyle } from 'styled-components'
import { Result } from './components/Result';
import { useLablifeStore } from './helpers/store';
import { getIDP } from './helpers/api';

const GlobalStyle = createGlobalStyle`
  .app {
    min-height: initial !important;
  }
`

interface LablifeAppProps {
  token: string;
  partner: string;
  email?: string;
}

export default function LablifeApp({ token, partner, email }: LablifeAppProps) {
  const [error, setError] = useState<Error | null>(null);
  const [translationsInit, setTranslationsInit] = useState(false);

  const { data, setData } = useLablifeStore();

  const initLng = async (lng: string) => {
    // await loadLocale(lng);
    // dayjs.locale(lng);
    setTranslationsInit(true);
  };

  useEffect(() => {
    i18n.on('loaded', async () => {
      await initLng(i18n.language);
    });
  }, []);

  useEffect(() => {
    const init = async () => {
      const userEmail = email?.toLowerCase() || searchParams().get('email')?.toLowerCase()  || '';

      if (userEmail) {
        const dataPost = {
          email: userEmail,
          token,
        };

        getIDP(dataPost).then((res) => {
          if(res) {
            setData(res);
          }
        });
      }
    }

    init();
  }, [email, token]);

  if (!translationsInit) {
    return (
      <AppEmptyPage>
        <Loader />
      </AppEmptyPage>
    );
  }

  return (
    <>
      <GlobalStyle />
      <Container>
        {
          data
            ? <Result token={token} partner={partner} data={data}/>
            : <Form token={token} partner={partner} setError={(value) => setError(value)} email={email} />
        }

        {error && (
          <StyledNotificationPopup
            type={'warning'}
            size={'small'}
            title={error.title}
            // @ts-ignore
            content={error.content}
            onClose={() => setError(null)}
          />
        )}
      </Container>
    </>
  );
}

const Container = styled.div`
  width: 100%;
`;

const StyledNotificationPopup = styled(NotificationPopup)`
  & > div {
    border-radius: 0.4rem;
  }

  .title {
    text-align: left;
    margin-top: 2rem;
  }

  .content {
    text-align: left;
    margin-top: 1.5rem;
  }

  @media (max-width: 460px) {
    & > div {
      height: 40%;
    }
  }
`;
